export default "__VITE_ASSET__D2cR7cSa__"